import React from 'react';
import styles from './chezro.module.scss';
import Gallery from '../../components/gallery/Gallery';
import Header from '../../components/header/Header';
import Mission from '../../components/mission/Mission';
import SingleDescriptionBanner from '../../components/singleDescriptionBanner/singleDescriptionBanner';
import Title from '../../components/title/Title';
import TopBanner from '../../components/topBanner/TopBanner';
import Footer from '../../components/footer/Footer';
import DoubleDescSingleImg from '../../components/doubledescsingleimg/DoubleDescSingleImg';

const ChezRo = () => {
  return (
    <div className={styles.container}>
      <Header />
      <Title title="Chez Ro" subtitle="BRAND IDENTITY (DIGITAL MEDIA, PRINT)" />
      <TopBanner
        heroImg="/images/chezro_hero.svg"
        mainText="Hospitality & Culinary Services"
        subText="Chez Ro's branding was made specifically for what the client was; a chef. I wanted to 
create a logo that was both representative of the service he offered and his personality. The Chez Ro's brand had to feel exquisite and elegant. Understanding Ro's intent for his branding made it easier to create the perfect branding."
        imgOne="/images/chezro_brown_box.svg"
        imgTwo="/images/chezro_black_box.svg"
        pageName="chezro"
      />
      <Mission text="Developed an elegant brand identity for Chez Ro that reflects the chef’s personality and service, including logo design, merchandise, and custom illustrations." />
      <SingleDescriptionBanner
        heroImg="/images/chezro_deliv.svg"
        subText="The branding balances refinement with character, translating Ro’s culinary philosophy into a visual language that feels personal, elevated, and memorable. Every element was designed to work seamlessly across physical and digital touchpoints, ensuring the brand communicates craftsmanship, attention to detail, and a sense of understated luxury."
        imgOne="/images/reimagined1.svg"
        imgTwo="/images/reimagined2.svg"
        pageName="chezro"
      />
      <div className={styles.img_container}>
        <img src="/images/chezropotrait.svg" alt="image" />
      </div>
      <Gallery
        topImgOne="/images/Chezro_cards_1.svg"
        topImgTwo="/images/chezrocards2.svg"
        bottomImg="/images/chezro_ig.svg"
        pageName="chezro"
      />
      <DoubleDescSingleImg
        heroImg="/images/joos.svg"
        mainText="Hospitality & Culinary Services"
        subText="Chez Ro's branding was made specifically for what the client was; a chef. I wanted to 
create a logo that was both representative of the service he offered and his personality. The Chez Ro's brand had to feel exquisite and elegant. Understanding Ro's intent for his branding made it easier to create the perfect branding."
        imgOne="/images/chezro_drinks.svg"
        pageName="chezro"
      />
      <Footer />
    </div>
  );
};

export default ChezRo;
